require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /Users/v625154/work/perspective/node_modules/core-js/modules/es7.symbol.async-iterator.js
// module id = 52
// module chunks = 0